import React from 'react'

import IconLoading from '@/assets/lottie/loading.json'

import clsx from 'clsx'
import Lottie from 'lottie-react'

interface OverlayLoadingProps {
  className?: string
  isVisible?: boolean
}

export const OverlayLoading: React.FC<OverlayLoadingProps> = ({ className, isVisible = true }) => {
  if (!isVisible) return null

  return (
    <div
      className={clsx('absolute w-full h-full flex items-center justify-center bg-white-4 opacity-30', className)}
      style={{ zIndex: 9999 }}
    >
      <div className='rounded-sm p-4'>
        <Lottie animationData={IconLoading} className='mx-auto size-6' loop={true} />
      </div>
    </div>
  )
}
